import { render, staticRenderFns } from "./chat_archivio.vue?vue&type=template&id=569ab6a0&scoped=true&"
import script from "./chat_archivio.vue?vue&type=script&lang=js&"
export * from "./chat_archivio.vue?vue&type=script&lang=js&"
import style0 from "./chat_archivio.vue?vue&type=style&index=0&id=569ab6a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569ab6a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VCard,VCardText,VCardTitle,VList})
